<template>
  <div>
    <div v-if="birthdaysData && Object.keys(birthdaysData).length > 0"
      class="flex flex-col p-4 bg-white border border-gray-300 rounded w-full">
      <div class="flex">
        <zt-icon name="calendar-birthday" class="w-6 h-6 text-gray-500 icon-birthday pt-1" />
        <h1 class="text-xl font-medium ml-2">{{ $t('message.dashboard.birthday') }}</h1>
      </div>
      <div class="h-502 mt-3">
        <div v-for="(group, day) in birthdaysData" :key="day" class="p-2 ">
          <div class="flex justify-between">
            <p class="text-lg font-semibold">
              {{ group.daysdiff === -1 ? $t("message.homeComponent.birthdays.yesterday") : group.daysdiff === 0 ?
                $t("message.homeComponent.birthdays.today") : group.daysdiff === 1 ?
                  $t("message.homeComponent.birthdays.tomorrow") :
                  group.daysdiff > 7 ? $t("message.homeComponent.birthdays.next") : group.diaSemana }}
            </p>
            <p v-if="group.daysdiff < 7" class="text-gray-500">{{ group.fecha }}</p>
          </div>
          <div v-for="(item, index) in group.cumplen" :key="index" class="flex items-center my-2">
            <div class="border border-gray-300 rounded p-2 flex items-center">
              <zt-avatar class="avatarWidth" v-if="item.foto_perfil" :src="item.foto_perfil" />
              <zt-avatar class="avatarWidth" v-else :text="item.iniciales" :color="item.color" />
              <p class="ml-4">{{ item.nombreyapellido }} </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="flex bg-white rounded  border border-gray-300 p-6 ml-2">
      <div class="flex justify-center ">
        <DesertSVG />
      </div>

      <div class="text-center md:text-left mt-4 mr-12">
        <h1 class="text-2xl font-semibold text-gray-700">
          {{ $t('message.dashboard.notFound.title') }}
        </h1>
        <h2 class=" text-gray-600 font-medium py-2">
          {{ $t('message.dashboard.notFound.description') }}
        </h2>
      </div>
    </div>
  </div>
</template>

<script>
import DesertSVG from '@/components/commons/Illustrations/graphicSVG/DesertSVG'
import Users from '@/apiClient/Users.js'
export default {
  name: "UpcomingBirthdays",
  components: {
    DesertSVG
  },
  data() {
    return {
      birthdaysData: null,
    }
  },
  async created() {
    this.userApi = new Users();
    await this.getBirthdays()
  },
  methods: {
    async getBirthdays() {
      try {
        const response = await this.userApi.getBirthdays();
        const cumplenData = response.data.results.data
        this.birthdaysData = this.calculateModifiedData(cumplenData);
      } catch (error) {
        this.birthdaysData = []
      }
    },

    calculateModifiedData(data) {
      const daysOfWeek = this.$t("message.menuComponent.weekDays").split(",");
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const modifiedData = data.map(item => {
        const fechaParts = item.fecha.split('/');
        const itemDate = new Date(fechaParts[2], fechaParts[1] - 1, fechaParts[0]);
        const daysDiff = Math.ceil((itemDate - today) / (1000 * 60 * 60 * 24));
        const dayOfWeekIndex = itemDate.getDay();
        return {
          daysdiff: daysDiff,
          diaSemana: daysOfWeek[dayOfWeekIndex],
          ...item,
        };
      });

      const groupedData = modifiedData.reduce((acc, item) => {
        if (item.daysdiff < 7) {
          acc.push(item);
        } else {
          if (!acc.some(group => group.daysdiff >= 7)) {
            acc.push({
              daysdiff: 7,
              diaSemana: this.$t("message.homeComponent.birthdays.next"),
              cumplen: [],
            });
          }
          const proximosGroup = acc.find(group => group.daysdiff >= 7);
          proximosGroup.cumplen.push(...item.cumplen);
        }
        return acc;
      }, []);

      return groupedData;

    },
  },
}
</script>

<style lang="scss" scoped>
.icon-birthday {
  font-size: 20px;
  color: #000;
}

.avatarWidth {
  min-width: 35px;
}

.h-502 {
  max-height: 402px;
  overflow-y: auto;
}
</style>